export default __webpack_public_path__ + "static/media/placeholder_dummy2016-irishpub01-mobile-de.4564a711.png";